import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"
import {STICKY_HEADER_SCROLL_TRIGGER} from "../../config/constants"

interface BreadcrumbsSectionProps {
    isMobile: boolean
    isDesktop: boolean
}

export const NoResultsContainer = styled("div")`
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.875rem;

    @media (min-width: ${breakpoints.values.md}px) {
        padding-left: 2rem;
        padding-right: 2rem;
        padding-top: 1.375rem;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        padding-top: 1.625rem;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        padding-left: 2.5rem;
        padding-right: 2.5rem;
        padding-top: 1.625rem;
    }
`

export const CategoryQuickLinksContainer = styled("div")`
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-bottom: 50px;

    @media (min-width: ${breakpoints.values.md}px) {
        padding-left: 2rem;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        padding-right: 2rem;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        padding-left: 2.5rem;
        padding-right: 2.5rem;
    }
`

export const BreadcrumbsContainer = styled("div", {shouldForwardProp: prop => prop !== "sticky"})<{sticky: boolean}>`
    position: fixed;
    top: ${({sticky}) => (sticky ? `var(--next-header-scroll-height, 2.75rem)` : "var(--next-header-height, 5.5rem)")};
    @media (min-width: ${breakpoints.values.md}px) {
        top: calc(var(--next-header-md-height, 6.5625rem));
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        top: calc(var(--next-header-lg-height, 6.5625rem));
    }
    width: 100%;
    z-index: 2;
    height: 2.25rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: ${({theme}) => theme.colours.components.breadcrumb.default.backgroundColor};
    border-bottom: ${({theme}) => `1px solid ${theme.colours.components.breadcrumb.default.borderBottomColor}`};
    border-top: ${({theme}) => `1px solid ${theme.colours.components.breadcrumb.default.borderTopColor}`};
`

export const BreadcrumbsSection = styled("div")`
    height: 2.25rem;
`

export const RelativeContainer = styled("div")`
    min-height: ${STICKY_HEADER_SCROLL_TRIGGER}px;
    width: 100%;
    position: relative;
    z-index: 4;
    height: 3.5rem;
    @media (min-width: ${breakpoints.values.lg}px) {
        display: none;
    }
`
